export default "__VITE_ASSET__DnjAzieP__"